import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Grid,
  Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import BoardCard from './BoardCard';
import CustomPagination from '../../CustomPagination';

/**
 * Modal para mostrar todos los tableros de una categoría
 * Sigue el principio de responsabilidad única (SRP) de SOLID
 */
const BoardsModal = ({ open, onClose, title, boards, onTogglePinned, pinnedBoards, onViewDetails }) => {
  const [page, setPage] = useState(0);
  const rowsPerPage = 10; // Número de tableros por página (aumentado a 10 para ver más)

  // Calcular los tableros a mostrar en la página actual
  const displayedBoards = boards.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="boards-modal-title"
      maxWidth="xl"
      fullWidth
    >
      <DialogTitle id="boards-modal-title">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h3" component="h2">
            {title}
          </Typography>
          <IconButton onClick={onClose} aria-label="cerrar">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 3, maxHeight: '80vh', overflow: 'auto' }}>
        <Grid container spacing={3}>
          {displayedBoards.map((board) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={board.id}>
              <BoardCard 
                board={board} 
                onTogglePinned={onTogglePinned}
                isPinned={pinnedBoards.some(b => b.id === board.id)}
                onViewDetails={onViewDetails}
              />
            </Grid>
          ))}
        </Grid>
        
        {/* Paginación para el modal */}
        <Box display="flex" justifyContent="center" mt={3}>
          <CustomPagination
            count={boards.length}
            rowsPerPage={rowsPerPage}
            page={page}
            setPage={setPage}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default BoardsModal;